import { parseSherbertAssetUrl, createVariantUrl } from '@cimpress-technology/assets-sdk';

export async function getPreviewUrl(url: string): Promise<string> {
    const parsed = parseSherbertAssetUrl(url);
    if (!parsed) throw new Error(`Cannot get preview URL: not a valid Sherbert asset URL`);
    return createVariantUrl({
        assetInfo: { id: parsed.assetId, version: parsed.version },
        options: {
            variants: [{ variant: 'webPreview' }],
            signature: parsed.signature,
        },
    });
}
